export const createDefaultKPI = () => ({
    id: "default-kpi",
    name: "All Interactions",
    description: "No KPI filter applied",
    filters: {
        requiresCallback: false,
        controlledTransfersOnly: false,
        blindTransfersOnly: false,
        handoffTransfersOnly: false,
    },
    thresholds: {
        excellent: 5,
        good: 15,
        acceptable: 30,
    },
    createdAt: new Date().toISOString(),
});
export const createKPI = (name, filters, thresholds) => ({
    id: `kpi-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
    name,
    filters,
    thresholds: {
        excellent: 5,
        good: 15,
        acceptable: 30,
        ...thresholds,
    },
    createdAt: new Date().toISOString(),
});
//# sourceMappingURL=kpi.js.map